module.exports = __webpack_public_path__ + "img/new_age_01.6d590cd6.jpg";